@if (row()["empty"]) {
    @if (column().displayFormatId === displayFormat.Avatar) {
        <ngx-skeleton-loader
            data-testid="table-cell-skeleton"
            appearance="circle"
            [theme]="{ width: '30px', height: '30px', marginBottom: 0 }" />
    } @else {
        <ngx-skeleton-loader
            data-testid="table-cell-skeleton"
            [theme]="{ width: '100%', height: '12px', marginBottom: 0 }" />
    }
} @else {
    @let cellData = row()[column().name];
    @if (["", null, undefined].includes(cellData)) {
        <!-- If we have align on column, use that. Else - align numbers to end -->
        <p
            [ngClass]="
                column().align
                    ? 'text--' + column().align
                    : column().displayFormatId === displayFormat.Number
                      ? 'cipo--text--end'
                      : ''
            ">
            {{ noDataPlaceholder() }}
        </p>
    } @else {
        @switch (column().displayFormatId) {
            @case (displayFormat.YesNo) {
                <p [ngClass]="column().align && 'text--' + column().align">
                    {{ "general.boolValue." + cellData | translateInsensitive }}
                </p>
            }
            @case (displayFormat.Status) {
                <cipo-state
                    [bgColor]="cellData['bgColor']"
                    [textColor]="cellData['color']"
                    [name]="cellData['label']"
                    customClass="m-l-0" />
            }
            @case (displayFormat.Date) {
                <p
                    class="cipo--text--ellipsed"
                    [ngClass]="column().align && 'text--' + column().align"
                    [title]="cellData | itvDateTimeWithRestrictions: column().restrictions">
                    {{ cellData | itvDateTimeWithRestrictions: column().restrictions }}
                </p>
            }
            @case (displayFormat.Image) {
                <div
                    class="cipo--display--inline-block cipo--position--relative cipo--vertical-align--middle"
                    [title]="cellData">
                    @if (column().showThumbnail) {
                        <cipo-img-base64
                            [base64]="row()[column().name + '_thumb']"
                            [height]="40"
                            [mimetype]="cellData | getMimeType"></cipo-img-base64>
                    } @else if (cellData.type === "image") {
                        <!-- Pass the entire row (attachment) to imageSource, because it contains mimetype, thumbnail -->
                        <img
                            [src]="$any(row()) | imageSource"
                            [class]="cellData.class"
                            [style.height]="'40px'"
                            alt="" />
                    } @else if (cellData.iconKey) {
                        <mat-icon [class]="cellData.class">{{ cellData.iconKey }}</mat-icon>
                    } @else {
                        <p class="cipo--text--ellipsed">{{ cellData }}</p>
                    }
                    @for (badge of cellData.badges; track badge.iconKey; let i = $index) {
                        <mat-icon
                            class="cell-badge cipo-icon cipo-icon--sm material-icons cipo--position--absolute"
                            role="img"
                            [ngClass]="badge.class"
                            [style.bottom.px]="0"
                            [style.right.px]="-6 + i * 14"
                            [title]="badge.title | translate"
                            [attr.aria-label]="badge.title | translate">
                            {{ badge.iconKey }}
                        </mat-icon>
                    }
                </div>
            }
            @case (displayFormat.Avatar) {
                <div>
                    @if (!cellData.base64) {
                        <mat-icon
                            [class]="cellData.class"
                            [ngStyle]="{
                                'border-radius': cellData.radius || '50%',
                                height: (cellData.height || 40) + 'px',
                                width: (cellData.height || 40) + 'px',
                                'line-height': (cellData.height || 40) + 'px',
                            }">
                            {{ cellData.iconKey }}
                        </mat-icon>
                    } @else {
                        <cipo-img-base64
                            [base64]="cellData.base64"
                            [height]="cellData.height || 40"
                            [radius]="cellData.radius || '50%'"
                            [mimetype]="cellData.mimeType" />
                    }
                </div>
            }
            @case (displayFormat.Number) {
                <p
                    class="cipo--text--ellipsed"
                    [ngClass]="column().align ? 'cipo--text--' + column().align : 'cipo--text--end'"
                    [title]="
                        cellData
                            | itvNumberWithFormattings
                                : column().formattings
                                : column().restrictions
                                : userStore.currency()
                    ">
                    {{
                        cellData
                            | itvNumberWithFormattings
                                : column().formattings
                                : column().restrictions
                                : userStore.currency()
                    }}
                </p>
            }
            @case (displayFormat.Froala) {
                <p class="cipo--text--ellipsed" [title]="cellData | stripHtml" [innerHTML]="cellData | safeHtml"></p>
            }
            @case (displayFormat.TranslateKey) {
                <p class="cipo--text--clamped" [title]="cellData | translate">
                    {{ cellData | translate }}
                </p>
            }
            @case (displayFormat.IconText) {
                <span class="dl-cell cipo--gap--sm" [attr.title]="cellData.title || cellData.text || null">
                    @if ((cellData.iconPosition ?? "before") === "before" && cellData.iconKey) {
                        <mat-icon [class]="cellData.iconClass" [style.color]="cellData.color || null">
                            {{ cellData.iconKey }}
                        </mat-icon>
                    }
                    @if (cellData.text) {
                        <span class="cipo--text--clamped">{{ cellData.text }}</span>
                    }
                    @if (cellData.iconPosition === "after" && cellData.iconKey) {
                        <mat-icon [class]="cellData.iconClass" [style.color]="cellData.color || null">
                            {{ cellData.iconKey }}
                        </mat-icon>
                    }
                </span>
            }
            @default {
                <p class="cipo--text--clamped" [title]="cellData">
                    {{ cellData }}
                </p>
            }
        }
    }
}
